import Vue from 'vue'
import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import api from "@/api";

import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

/**
 * 注入 api 模块
 * api 模块封装了大部分的后台接口请求
 */
Vue.prototype.$api = api;

Vue.config.productionTip = false
Vue.use(Antd);
new Vue({
  render: h => h(App),
}).$mount('#app')